import { render, staticRenderFns } from "./HeadingMenu.vue?vue&type=template&id=6864c52c&"
import script from "./HeadingMenu.vue?vue&type=script&lang=js&"
export * from "./HeadingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports